/* Хлебные крошки: где человек находится и как вернуться на шаг вверх.

   Путь считаем по маршруту, а не по истории переходов: на карточку сделки
   приходят и из CRM, и из алертов, и по ссылке из бота — история у всех разная,
   а место записи в системе одно. Крошки поэтому всегда показывают одно и то же:
   раздел, в котором запись живёт, и, если есть, её родителя.

   Последняя крошка — сама страница, она не кликается. Верхнего уровня
   («Обзор», «Финансы», «CRM», «Алерты», «Ещё») у крошек нет — там и так видно,
   где ты, а лишняя строка съедала бы первый экран. */

/** Раздел, из которого приходят: он же первая крошка */
const CRM = { label: "CRM", to: "/crm" };
const FINANCE = { label: "Финансы", to: "/finance" };
const MORE = { label: "Ещё", to: "/more" };

/* Формы правки открываются из разных разделов, поэтому раздел у каждой свой.
   Подпись — то, что правится, а не «Правка»: заголовок в шапке и так её называет. */
const EDIT_CRUMBS = {
  operations: [FINANCE, { label: "Операция" }],
  payments: [FINANCE, { label: "Поступление" }],
  inflow: [FINANCE, { label: "Приток" }],
  deals: [CRM, { label: "Сделка" }],
  contacts: [CRM, { label: "Контакт" }],
  projects: [CRM, { label: "Проект" }],
  devTasks: [CRM, { label: "Разработка" }],
  users: [MORE, { label: "Люди", to: "/manage/users" }, { label: "Участник" }],
  businesses: [MORE, { label: "Бизнесы", to: "/manage/businesses" }, { label: "Бизнес" }],
  goals: [MORE, { label: "Цели", to: "/manage/goals" }, { label: "Цель" }],
  recurring: [MORE, { label: "Расходы", to: "/manage/recurring" }, { label: "Расход" }],
  passwords: [MORE, { label: "Пароли", to: "/passwords" }, { label: "Запись" }],
  cards: [MORE, { label: "Карты", to: "/cards" }, { label: "Карта" }],
};

/** У каких записей форма правки открывается поверх своей страницы */
const CARD_OF = { deals: "/deal", projects: "/project", devTasks: "/devtask" };

/* Разделы «Ещё»: подписи те же, что на плитках, иначе крошка и плитка
   назывались бы по-разному и читались как разные места */
const MORE_PAGES = {
  "/businesses": "Бизнесы",
  "/reports": "Отчёты",
  "/meetings": "Саммери встреч",
  "/instagram": "Скачать из Instagram",
  "/pdf": "Сжатие PDF",
  "/passwords": "Пароли и ссылки",
  "/cards": "Карты",
  "/shortcut": "Шорткат",
  "/bot": "Демо бота",
};

const MANAGE_PAGES = {
  users: "Люди",
  businesses: "Бизнесы и счета",
  goals: "Цели",
  recurring: "Регулярные расходы",
};

/**
 * Крошки текущего экрана.
 * @param {string} pathname — путь без query
 * @returns {{label: string, to?: string}[]} последняя крошка — сама страница
 */
export function crumbsOf(pathname) {
  const parts = String(pathname || "").split("/").filter(Boolean);
  const [head, a, b] = parts;

  if (MORE_PAGES[pathname]) return [MORE, { label: MORE_PAGES[pathname] }];

  switch (head) {
    case "manage":
      return MANAGE_PAGES[a] ? [MORE, { label: MANAGE_PAGES[a] }] : [];

    case "edit": {
      const trail = EDIT_CRUMBS[a];
      if (!trail) return [];
      /* У сделки, проекта и карточки разработки есть своя страница — из формы
         правки логично вернуться в неё, а не сразу в раздел. У новой записи
         возвращаться некуда, у операции и платежа своей страницы нет вовсе. */
      const card = CARD_OF[a];
      if (!card || b === "new") return trail.map((c) => ({ ...c }));
      const parents = trail.slice(0, -1).map((c) => ({ ...c }));
      const self = trail[trail.length - 1];
      return [...parents, { ...self, to: `${card}/${b}` }, { label: "Правка" }];
    }

    case "deal":
      return [CRM, { label: "Сделка" }];

    /* План проекта — единственный экран третьего уровня: до него доходят
       из карточки, и вернуться в неё крошкой быстрее, чем кнопкой «назад» */
    case "project":
      return b === "plan"
        ? [CRM, { label: "Проект", to: `/project/${a}` }, { label: "План и факт" }]
        : [CRM, { label: "Проект" }];

    case "devtask":
      return [CRM, { label: "Разработка" }];

    case "schedule":
      return [CRM, { label: "Повторяющийся платёж" }];

    case "meeting":
      return [MORE, { label: "Саммери встреч", to: "/meetings" }, { label: "Встреча" }];

    default:
      return [];
  }
}
